'use strict';

// eslint-disable-next-line max-lines-per-function, max-params
angular.module('webAgro1App').controller('GlebasCtrl', function(
  $route, $location, $scope, $rootScope, $routeParams, $timeout,
  GlebasService, Flash, LoadingService, MessagesService,
  PropriedadesService
) {
  $scope.glebas = [];
  $scope.idMapContentGleba = ID_MAP_GLEBA;
  $scope.cadastroGleba = {
    status: 'active',
    propriedade: {}
  };

  const error = function() {
    Flash.create(FALHA_AO_CONSULTAR_REGISTRO.type, FALHA_AO_CONSULTAR_REGISTRO.msg);
    $location.path('/glebas');
  };

  const initializeMap = function() {
    if ($scope.gleba.tem_kml) {
      GlebasService.getMapGleba($scope.idMapContentGleba, $scope.gleba).then(function(result) {
        $scope.glebaMapa = result;
      })
        .finally(LoadingService.hideLoading);
    } else {
      LoadingService.hideLoading();
    }
  };

  // eslint-disable-next-line max-lines-per-function
  const initialize = function() {
    LoadingService.showLoading();
    if (document.getElementById($scope.idMapContentGleba)) {
      document.getElementById($scope.idMapContentGleba).outerHTML = '';
    }

    $rootScope.initialize.then(function() {
      if (!$rootScope.permissions.glebas.canRead) {
        $location.path('/');
        Flash.create(ACESSO_NAO_PERMITIDO.type, ACESSO_NAO_PERMITIDO.msg);
        return;
      }

      if ($routeParams.id) {
        GlebasService.get($routeParams.id).then(function(data) {
          $scope.gleba = data.data || {};
          if (!$scope.gleba.id) {
            error();
          } else {
            $timeout(initializeMap, 500);
          }
        }, error);
      } else {
        PropriedadesService.all().then(function(propriedades) {
          $scope.propriedadesGlebas = propriedades.data || [];
          $scope.list();
        }, function() {
          MessagesService.alert('Não foi possível carregar as propriedades.');
          $rootScope.errorRootInitialize();
        });
      }
    }, $rootScope.errorRootInitialize);
  };

  $scope.list = function(propriedade) {
    if (!(propriedade || {}).id) {
      propriedade = $rootScope.propriedadeGlebas || $rootScope.currentPropriedade || $scope.propriedadesGlebas[0];
    }
    $scope.cadastroGleba.propriedade = propriedade;

    LoadingService.showLoading();
    $scope.glebas = [];

    const filters = {
      propriedade: propriedade.id,
      status: $scope.cadastroGleba.status
    };

    GlebasService.list(filters).then(function(data) {
      $scope.glebas = data.data || [];
      $scope.glebas.forEach(function(gleba) {
        gleba.linkKml = $scope.getLinkKml(gleba);
      });
    }, function() {
      MessagesService.alert('Não foi possível buscar os talhões da propriedade selecionada.');
    })
      .finally(LoadingService.hideLoading);
  };

  $scope.getLinkKml = function(gleba) {
    const token = $scope.currentUser.token;
    if (gleba.tem_kml) {
      return `${SERVER + API_VERSION}glebas/${gleba.id}/kml?token=${token}`;
    }
  };

  $scope.inactivate = function(id) {
    MessagesService
      .confirm('Deseja realmente inativar este talhão?')
      .then(async() => {
        LoadingService.showLoading();
        try {
          await GlebasService.inactivate(id);
          initialize();
        } catch {
          MessagesService.alert('Não foi possível inativar o talhão.');
          LoadingService.hideLoading();
        }
      });
  };

  $scope.activate = function(id) {
    MessagesService
      .confirm('Reativar talhão?')
      .then(async() => {
        LoadingService.showLoading();
        try {
          await GlebasService.activate(id);
          initialize();
        } catch {
          MessagesService.alert('Não foi possível reativar o talhão.');
          LoadingService.hideLoading();
        }
      });
  };

  initialize();

  $scope.show = function(index) {
    const gleba = $scope.glebas[index];

    if (gleba) {
      $location.path(`/glebas/${ gleba.id}`);
    }
  };

  $scope.goToIndex = function() {
    $location.path('/glebas');
  };

  $scope.edit = function() {
    $location.path(`/glebas/${ $scope.gleba.id }/edit`);
  };

  $scope.simplify = function(event, gleba) {
    event.preventDefault();
    MessagesService.confirm('Deseja realmente otimizar o KML desse talhão? Essa ação é IRREVERSÍVEL.').then(function() {
      LoadingService.showLoading();
      GlebasService
        .simplify(gleba.id)
        .then(function(result) {
          const { data } = result;
          MessagesService
            .alert(`Talhão otimizado com sucesso.
              De ${(data.old_size_kb / 1024).toLocaleString()}kb para ${(data.new_size_kb / 1024).toLocaleString()}kb`);
          $route.reload();
          initialize();
        })
        .catch(function() {
          MessagesService.alert('Falha ao otimizar o talhão.');
          LoadingService.hideLoading();
        });
    });
  };
});
